
import { Component, OnInit } from '@angular/core';
import { IContact, UserData } from '@osapp/model';
import { DestroyableComponentBase } from '@osapp/modules/utils/components/destroyable-component-base';
import { ContactsService, PlatformService } from '@osapp/services';
import { ITerminal } from 'apps/idl/src/modules/olaqin/models/iterminal';
import { SceService } from 'apps/idl/src/modules/sce/services/sce.service';
import { EMPTY, from, Observable, of } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { PanneauAjoutAppareilComponent } from '../../../shared/components/panneaux/panneau-ajout-appareil/panneau-ajout-appareil.component';
import { PanneauConnecterLecteurComponent } from '../../../shared/components/panneaux/panneau-connecter-lecteur/panneau-connecter-lecteur.component';
import { PanneauTesterLecteurComponent } from '../../../shared/components/panneaux/panneau-tester-lecteur/panneau-tester-lecteur.component';
import { EDeviceType } from '../../../shared/enums/EDeviceType';
import { LecteurStorageService } from '../../../shared/services/lecteurStorage.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { PanneauService } from '../../../shared/services/panneau.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';

@Component({
  selector: 'di-lecteur',
  templateUrl: './lecteur.component.html',
  styleUrls: ['./lecteur.component.scss'],
})
export class LecteurComponent extends DestroyableComponentBase implements OnInit  {
  public showMenu = false;
  public listTerminals: ITerminal[];
  public currentUser: IContact;
  public deviceIdRegistered: boolean = false;
  public deviceType: EDeviceType;

  constructor(
    private svcSnackbar: SnackbarService,
    private svcLoader: LoaderService,
    private svcPanneau: PanneauService,
    private svcContacts: ContactsService,
    private svcSCE: SceService,
    private svcLecteurStorage: LecteurStorageService,
    private svcPlatform: PlatformService
  ) {
    super();
  }

  ngOnInit() {
    this.svcLoader.showLoader("Récupération des lecteurs disponibles...");
    this.deviceType = this.svcPlatform.getDeviceType();
    this.getCurrentUser().pipe(
      switchMap(() => this.getListTerminal()),
      switchMap(() => this.enableAjoutAppareil()),
      tap(() => {
        this.svcLoader.hideLoader();
      }),
      takeUntil(this.destroyed$)
    ).subscribe();

    this.svcPanneau.closePanel$.pipe(
      tap(() => {
        this.svcLoader.showLoader("Récupération des lecteurs disponibles...");
      }),
      switchMap(() => this.getListTerminal()),
      switchMap(() => this.enableAjoutAppareil()),
      tap(() => {
        this.svcLoader.hideLoader();
      }),
      takeUntil(this.destroyed$)
    ).subscribe();
  }

  handleShowMenu() {
    this.showMenu = true;
  }

  handleCloseMenu() {
    this.showMenu = false;
  }

  openPanneauAjoutAppareil(terminal?: ITerminal) {
    this.showMenu = false;
    this.svcPanneau.open(terminal ? "Modifier l'appareil" : "Ajouter cet appareil", PanneauAjoutAppareilComponent, { terminal, currentUser: this.currentUser });
  }

  public getCurrentUser(): Observable<IContact>{
    return this.svcContacts.getContact(ContactsService.getContactIdFromUserId(UserData.current._id)).pipe(
      tap((contact: IContact | null) => {
        this.currentUser = contact;
      })
    )    
  }

  public getListTerminal(): Observable<ITerminal[]> {
    if (!this.currentUser?.finess) {
      this.svcSnackbar.showToast(
        "error",
        "bottom center",
        "Le n° FINESS du praticien n'est pas défini.",
        null,
        null,
        null,
        "7000"
      );
      return EMPTY;
    }
    return this.svcSCE.listTerminals(this.currentUser.finess, this.currentUser.rpps ?? this.currentUser.adeli ?? "", false).pipe(
      map((terminals: ITerminal[]) => {
        return terminals.filter((term) => term.device)
      }),
      tap((terminals: ITerminal[]) => {
        this.listTerminals = terminals;
      })
    )
  }

  public enableAjoutAppareil(): Observable<any>{
    if (this.deviceType === EDeviceType.ANDROID) {
      return from(this.svcLecteurStorage.getDeviceId()).pipe(
        tap((deviceId) => {
          if (deviceId) {
            this.deviceIdRegistered = true;
            this.listTerminals.forEach((term) => {
              if (term.terminalId === deviceId) {
                term.isCurrentDevice = true;
              }
            })
          }
        })
      )
    }
    return of(null);
  }

  public openPanneauConnecterLecteur(): void {
    this.showMenu = false;
    this.svcPanneau.open("Sélectionner un lecteur", PanneauConnecterLecteurComponent, {});
  }

	public openPanneauEcouterAppareil(): void {
    this.showMenu = false;
    this.svcPanneau.open("Diagnostique de mon appareil", PanneauTesterLecteurComponent, {});
  }
}
